import { Injectable } from '@angular/core';

import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { Observable, Subject, map } from 'rxjs';

@Injectable()
export class PendingPayoutInfoService {
    private toggleState: StringDictionary<boolean> = {};
    private visibleSubject$ = new Subject<StringDictionary<boolean>>();

    visible$(id: string): Observable<boolean> {
        return this.visibleSubject$.asObservable().pipe(map((x) => x[id]));
    }

    set visible(value: { id: string; visible: boolean }) {
        this.toggleState[value.id] = value.visible;
        this.visibleSubject$.next(this.toggleState);
    }
}
